import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import Button from "../../../../general/button/button.component";
import db, { storage, app } from "../../../../../firebase.config";
import { uploadBytes, ref } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import * as yup from "yup";
import { textAlign } from "@mui/system";

const dataSetter = async (hasUploadedUSN) => {
  const studentRef = doc(db, "studentData", hasUploadedUSN);
  setDoc(studentRef, { hasUploadedResume: true }, { merge: true });
};

const schema = yup.object().shape({
  file: yup
    .mixed()
    .test("required", "You need to provide a file", (value) => {
      return value && value.length;
    })
    .test("fileSize", "The file is too large", (value, context) => {
      return value && value[0] && value[0].size <= 20 * 1024 * 1024;
    })
    .test("type", "Only pdfs allowed", function (value) {
      return value && value[0] && value[0].type === "application/pdf";
    }),
});

function Upload({ hasUploadedUSN }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    // alert(
    //   JSON.stringify({
    //     fileName: data.file[0].name,
    //     type: data.file[0].type,
    //     size: `${data.file[0].size} bytes`,
    //   })
    // );
    const storageResumeRef = ref(storage, `resumes/${data.file[0].name}`);
    uploadBytes(storageResumeRef, data).then((snapshot) => {
      alert("Uploaded resume!");
    });
    dataSetter(hasUploadedUSN).then((response) => {
      console.log(response);
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div class="input-group mb-3">
        <label class="input-group-text" htmlFor="file">
          Upload pdf
        </label>
        <input
          class="form-control"
          id="file"
          {...register("file")}
          type="file"
        />
      </div>

      {errors.file && <p>{errors.file.message}</p>}
      <Grid container justifyContent="center" sx={{ mt: 5, md: 5 }}>
        <Grid item>
          <Button type="submit" text="Upload Resume">
            Upload Resume
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default Upload;
